import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'lean-step-vertical',
  templateUrl: './lean-step-vertical.component.html',
  styleUrls: ['./lean-step-vertical.component.scss']
})
export class LeanStepVerticalComponent implements OnInit {

  @Input() stepIndex      : number;
  @Input() stepAlias      : number;
  
  @Input() currentIndex   : number;
  @Input() passed         : boolean;
  @Input() first          : boolean;
  @Input() last           : boolean;


    constructor() { }

  ngOnInit() {
  }


  getIcon() : string {
    if (this.stepIndex == this.currentIndex) return "assets/images/icons/circle-blue.png";
    return "assets/images/icons/circle-blue-empty.png";
 //   if (this.passed)                          return "assets/images/icons/circle-blue.png";
 //   if (this.currentIndex == this.stepIndex)  return "assets/images/icons/circle-blue-empty.png";
 //                                             return  "assets/images/icons/circle-white.png";
  }

  getTextColorClass() : string{
    if (this.passed)  return "passed-text";
    return "neutral-text";
  }

}
